import { postJson, postForm, postDownload } from '@/utils/request'

// ===== 排班管理 =====
export function getRoomScheduleList(params) {
  return postJson('omc/roomSchedule/queryList', params)
}
export function addRoomSchedule(data) {
  return postJson('omc/roomSchedule/add', data)
}
export function editRoomSchedule(data) {
  return postJson('omc/roomSchedule/edit', data)
}
export function deleteRoomSchedule(id) {
  return postJson('omc/roomSchedule/delete', { id })
}
export function copyWeekSchedule(data) {
  return postJson('omc/roomSchedule/copyWeek', data)
}
export function exportSchedule(params) {
  return postDownload('omc/roomSchedule/exportSchedule', '排班记录.xls', params)
}

// ===== 班次设置 =====
export function getShiftList() {
  return postJson('omc/shifts/queryList', {})
}
export function addShift(data) {
  return postJson('omc/shifts/add', data)
}
export function editShift(data) {
  return postJson('omc/shifts/edit', data)
}
export function deleteShift(id) {
  return postJson('omc/shifts/delete', { id })
}

// ===== 房间列表 =====
export function getRoomList() {
  return postJson('omc/Room/queryAllRooms', {})
}

// ===== 班组管理（注意 postForm / postJson 混用） =====
export function getNursingGroupList(name) {
  return postForm('omc/group/selectShowAll', name ? { name } : {})
}
export function getNursingGroupMembers(id) {
  return postJson('omc/group/selectById', { nursingGroupId: String(id) })
}
export function addNursingGroup(data) {
  return postJson('omc/group/groupAdd', data)
}
export function updateNursingGroupName(data) {
  return postForm('omc/group/updateNameById', data)
}
export function deleteNursingGroup(id) {
  return postForm('omc/group/groupDelById', { nursingGroupId: id })
}
export function addNursingGroupMembers(data) {
  return postJson('omc/group/groupAddNurse', data)
}
export function removeNursingMember(userId) {
  return postForm('omc/group/updateByUserId', { userId })
}
export function updateNursingGroupLeader(data) {
  return postForm('omc/group/updateById', data)
}
export function getNursingStaffList(params) {
  return postJson('omc/group/queryNursingList', params)
}

// 查询全量护工列表（用于下拉选人，不限班组）
export function getAllNursingStaff() {
  return postForm('omc/group/selectNursingShowAll', {})
}

// ===== 考勤记录 =====
export function getAttendanceList(params) {
  return postJson('omc/attendance/queryList', params)
}
export function exportAttendance(params) {
  return postJson('omc/attendance/exportAttendance', params)
}

// ===== 换班申请 =====
export function getSwapList(params) {
  return postJson('omc/swap/queryList', params)
}
export function approveSwap(data) {
  return postJson('omc/swap/approve', data)
}
